<div class="mon-chart position-relative">
    <div *ngIf="emptyDataMessage.length > 0 && areAllDataRowsEmpty()"
         class="charts-overlay">
        <span class="charts-overlay-text">
            {{ emptyDataMessage }}
        </span>
    </div>
    <canvas [attr.height]="height"
            *ngIf="!areAllDataRowsEmpty()"
            class="chart-bar"
            chartBase
            [chartType]="'bar'"
            [chartData]="data"
            [chartLabels]="labels"
            [chartSeries]="series"
            [chartOptions]="options"
            [chartDatasetOverride]="override"
            [chartColors]="colors">
    </canvas>
</div>
